import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Button, SelectChangeEvent, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Formik } from "formik";
import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FormControl from "@mui/material/FormControl";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { ColumnModel } from "../../../models/common.model";
import {
  GetPaymentRequestInfoResponse,
  GetPaymentSettlementResponse,
  GetPaymentSettlmentInfoResponse,
} from "../../../models/supplierPayment.model";
import {
  GetPaymentSettlementInfo,
  GetPaymentSettlementZipFile,
} from "../../../services/supplierPayment.service";
import DetailInfo_settlementRegister from "./DetailInfo_settlementRegister";
import DetailInfo_settlementRegisterHistory from "./DetailInfo_settlementRegisterHistory";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import ModalCancelPaymentSettlement from "../../../components/modals/ModalCancelPaymentSettlement";
import ModalPaymentSettlement from "../../../components/modals/ModalPaymentSettlement";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "supplierTitle", label: " نام پذیرنده" },
  { id: "supplierUserTitle", label: " کاربر پذیرنده" },
  {
    id: "requestPersianDate",
    label: "تاریخ درخواست",
  },
  {
    id: "settlementAmount",
    label: " مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "supplierIban",
    label: " شماره شبا پذیرنده ",
  },
  {
    id: "description",
    label: "توضیحات",
  },
];
let muiSelected: any;
export default function TablePaymentSettlmentInfo() {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const history = useHistory<{
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    from?: string;
  }>();
  const key =
    history.location.state !== undefined ? history.location.state!.id : null;

  const queryClient = useQueryClient();
  const classes = useStyles();
  const [sendConfirmation, setSendConfirmation] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [paymentKey, setPaymentKey] = useState<string>("");
  const [settlementAmount, setSettlementAmount] = useState<number>(0);
  const [reloadData, setReloadData] = useState<string>("");
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [data, setData] = React.useState<GetPaymentRequestInfoResponse[]>([]);
  const [detailInfo, setDetailInfo] = React.useState<
    GetPaymentSettlmentInfoResponse
  >();

  //   const [loanRequestOptions, setLoanRequestOptions] = React.useState<
  //     GetStatusResponse[]
  //   >([]);
  // const [
  //     supplierSettlementOptions,
  //     setSupplierSettlementOptions,
  // ] = React.useState<GetStatusResponse[]>([]);
  // const [
  //     loanRequestSourceOptions,
  //     setLoanRequestSourceOptions,
  // ] = React.useState<GetStatusResponse[]>([]);
  // const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
  //     GetStatusResponse[]
  // >([]);
  // const [supplierUserOptions, setSupplierUserOptions] = React.useState<
  //     GetStatusResponse[]
  // >([]);
  // const [requestDate, setRequestDate] = React.useState<
  //     Date[] | null | undefined
  // >(null);

  // React.useEffect(() => {
  //   if (props.exportExcel === true) {
  //     ExportGetRegisterLoansMutation.mutate(
  //         valueFilterData! ? valueFilterData! : new Filter()
  //     );
  //     props.setExportExcel(false);
  //   }
  // }, [props.exportExcel]);
  React.useEffect(() => {
    // if (props.exportExcel == true) {
    //   ExportGetRegisterLoansMutation.mutate(valueFilterData!);
    // }

    if (keyCacheSession) {
      getPaymentSettlementInfoMutation.mutate({
        paymentSettlementKey: keyCacheSession!,
      });
    }
  }, []);
  const {
    mutateAsync: getPaymentSettlementZipFileMutation,
    isLoading: isZipFile,
  } = useMutation(GetPaymentSettlementZipFile, {
    onSuccess: () => {},
  });
  const getPaymentSettlementInfoMutation = useMutation(
    GetPaymentSettlementInfo,
    {
      onSuccess: (result: GetPaymentSettlmentInfoResponse) => {
        if (result) {
          setData(result.supplierPayments!);
          setDetailInfo(result!);
        }
      },
    }
  );
  React.useEffect(() => {
    getPaymentSettlementInfoMutation.mutate({
      paymentSettlementKey: keyCacheSession!,
    });
  }, [reloadData]);

  const comingBack = (pathname: any) => {
    let id = window.sessionStorage.getItem("key-tablePaymentRequestInfo");
    history.replace({
      pathname: pathname,
      state: {
        id: id!,
        from: "SettlmentRegisterhistoryDetail",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };

  // let { data, isLoading } = useQuery<DashboardRequest[]>(
  //     "GetUserDashboards",
  //     (): Promise<DashboardRequest[]> => {
  //       return GetUserDashboards();
  //     },
  //     {
  //       onSuccess: (data) => {
  //         if (data != null && data.length > 0) {
  //           setUserDashboards(data);
  //         }
  //       },
  //     }
  //   );
  //   useQuery<GetStatusResponse[]>(LOAN_REQUEST_STATUS, getLoanRequestStatus, {
  //     onSuccess(data) {
  //       setLoanRequestOptions(data);
  //     },
  //   });

  //aaded go to stepper
  const dispatch = useDispatch();

  const handelDetail = (key: string) => {
    // handleSelectRow(rowIndex);
    window.sessionStorage.setItem("key-tablePaymentRequestInfo", key);
    history.push({
      pathname: `/Payment/paymentRequestInfo`,
      state: {
        id: key,
        from: "SettlmentRegisterhistoryDetail",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };
  const keyCacheSession = key
    ? key
    : window.sessionStorage.getItem("key-tablePaymentSettlmentInfo");
  const onClickCheckIcon = (key: string, settlementAmount: number) => {
    setPaymentKey(keyCacheSession!);
    setSettlementAmount(settlementAmount);
    setOpenVerifyModal(true);
  };
  const onClickCancelIcon = (key: string, settlementAmount: number) => {
    setPaymentKey(keyCacheSession!);
    setSettlementAmount(settlementAmount);
    setOpenCancelModal(true);
  };
  //     handleSelectRow(rowIndex);
  //     const valuesNationalCode = new GetCustomerRegistrationInfoRequest();
  //     valuesNationalCode.nationalCode = nationalCode;
  //     queryClient.setQueryData(REFRENCE_KEY, requestId);
  //     getCustomerRegistrationInfo(valuesNationalCode).then((data) => {
  //       if (data) {
  //         queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);

  //         queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
  //         queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
  //         queryClient.setQueryData(
  //           EXISTING_LOANREQUEST,
  //           data.existingLoanRequest
  //         );
  //         // setOpen(false);
  //       }
  //     });
  //   };
  //   const handleSelectRow = (rowIndex: any) => {
  //     const cachPageNumber = queryClient.getQueryData(
  //       TABLE_FILTER_REGISTER
  //     ) as FilterFinder;
  //     const filter = new FilterFinder();
  //     filter.rowNumber = rowIndex;
  //     setSelectedRow(rowIndex);
  //     queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  //   };

  //   const filter = new Filter();
  return (
    <div>
      {/* {props.isShow ? (
        <Box sx={{ flexGrow: 1 }}>
           <Formik
            initialValues={filter}
            onSubmit={(values) => {
              {
              }

              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
            }}
          ></Formik> 
        </Box>
      ) : (
        ""
      )} */}
      {detailInfo &&
        (detailInfo?.finalizePersianDate == "" ||
          detailInfo?.chequeDuePersianDate == "") && (
          <>
            <Box
              sx={{
                backgroundColor: "rgba(154,175,196,0.15)",
                borderRadius: "5px",
                marginBottom: "10px",
                height: "41px",
                boxShadow:
                  "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
              }}
              paddingY={"1rem"}
            >
              <Grid container spacing={3}>
                <Grid item xs={3} md={2}>
                  {/* <Tooltip title="خروجی اکسل" arrow>
                    <img
                      onClick={exportExcel}
                      className="cursorPointer"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginTop: "-2px",
                        marginRight: "10px",
                      }}
                      src="images/ExportXLS.svg"
                    />
                  </Tooltip> */}
                </Grid>

                <Grid item xs={9} md={10} style={{ textAlign: "left" }}>
                  <span
                    style={{ color: "#1D4A87", marginLeft: "20px" }}
                    className="cursorPointer"
                    onClick={() =>
                      getPaymentSettlementZipFileMutation({
                        paymentSettlementKey: keyCacheSession!,
                      })
                    }
                  >
                    <SaveAltIcon scale="scale(1.8) " />
                    &nbsp;دانلود مستندات
                  </span>
                  <span
                    style={{ color: "#28A745", marginLeft: "20px" }}
                    className="cursorPointer"
                    onClick={() =>
                      onClickCheckIcon(key!, detailInfo.settlementAmount!)
                    }
                  >
                    <CheckIcon scale="scale(1.8) " />
                    &nbsp;تایید تسویه
                  </span>
                  <span
                    style={{ color: "#E6123D", marginLeft: "30px" }}
                    className="cursorPointer"
                    onClick={() =>
                      onClickCancelIcon(key!, detailInfo.settlementAmount!)
                    }
                  >
                    <CloseIcon scale="scale(1.8) " />
                    &nbsp;لغو تسویه
                  </span>
                  <span
                    style={{ color: "#1D4A87", marginLeft: "20px" }}
                    className="cursorPointer"
                    onClick={() =>
                      comingBack("/Payment/SettlementWithReceiver")
                    }
                  >
                    &nbsp;بازگشت
                    <ArrowBackIosIcon style={{ width: "12px" }} />
                  </span>
                </Grid>
              </Grid>
            </Box>
            <DetailInfo_settlementRegister detailInfo={detailInfo!} />
          </>
        )}
      {(detailInfo?.finalizePersianDate ||
        detailInfo?.chequeDuePersianDate) && (
        <>
          <Box
            sx={{
              backgroundColor: "rgba(154,175,196,0.15)",
              borderRadius: "5px",
              marginBottom: "10px",
              height: "41px",
              boxShadow:
                "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
            }}
            paddingY={"1rem"}
          >
            <Grid container spacing={3}>
              <Grid item xs={3} md={2}>
                {/* <Tooltip title="خروجی اکسل" arrow>
                    <img
                      onClick={exportExcel}
                      className="cursorPointer"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginTop: "-2px",
                        marginRight: "10px",
                      }}
                      src="images/ExportXLS.svg"
                    />
                  </Tooltip> */}
              </Grid>

              <Grid item xs={9} md={10} style={{ textAlign: "left" }}>
                <Grid container xs={12}>
                  <Grid item xs={8}></Grid>

                  <Grid item xs={4}>
                    <span
                      style={{ color: "#1D4A87", marginLeft: "20px" }}
                      className="cursorPointer"
                      onClick={() =>
                        getPaymentSettlementZipFileMutation({
                          paymentSettlementKey: keyCacheSession!,
                        })
                      }
                    >
                      <SaveAltIcon scale="scale(1.8) " />
                      &nbsp;دانلود مستندات
                    </span>
                    <span
                      style={{ color: "#1D4A87", marginLeft: "20px" }}
                      className="cursorPointer"
                      onClick={() =>
                        comingBack("/Payment/PaymentSettlementHistory")
                      }
                    >
                      &nbsp;بازگشت
                      <ArrowBackIosIcon style={{ width: "12px" }} />
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <DetailInfo_settlementRegisterHistory detailInfo={detailInfo!} />
        </>
      )}
      <b style={{ color: "#1D4A87", fontSize: "15px" }}>
        <span
          style={{ color: "#1D4A87", fontSize: "15px", fontWeight: "bold" }}
        >
          &nbsp; &nbsp;لیست منتخب تسویه
          <span
            style={{
              color: "#1D4A87",
              fontSize: "14px",
              fontWeight: "normal",
              marginRight: "3px",
            }}
          >
            (
            {data?.length !== undefined && data?.length != null
              ? data?.length
              : 0}{" "}
            مورد){" "}
          </span>
        </span>
      </b>
      <div className="cardTableBorder mTop10">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                // selected={selectedRow === 0}
              >
                {/* <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell> */}
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                {/* <TableCell className="rowTHead colorTitle" align="right">
                  <span className="colorTitle textFont12 fontWeight">
                    وضعیت
                  </span>
                </TableCell> */}

                {/* <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                >
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                </TableCell> */}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() => handelDetail(row.key!)}
                  >
                    {/* <TableCell className="textFont12" style={{ width: "5px" }}>
                      {rowIndex + 1}
                    </TableCell> */}
                    {columns.map((column) => {
                      const value =
                        row[column.id as keyof GetPaymentRequestInfoResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    {/* <TableCell className="textFont12" align="right">
                      <b style={{ color: "#EE9D01" }}>در جریان</b>
                    </TableCell> */}
                    {/* <TableCell className="textFont12" align="right">
                                            {row.description}
                                        </TableCell> */}
                    {/* <TableCell
                      className={
                        rowIndex % 2 == 0 ? " stickyColO   " : " stickyColE  "
                      }
                    >
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        // className={
                        //     row.registrationRequestId &&
                        //         row.loanRequestStatus == "Assigned"
                        //         ? "colorTitle"
                        //         : "colorDesaible1"
                        // }

                        //  onClick={() => handelDetail(row.referenceKey)}
                      />
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <ModalPaymentSettlement
        openModel={openVerifyModal}
        setSendConfirmation={setSendConfirmation}
        setOpenVerifyModal={setOpenVerifyModal}
        paymentKey={paymentKey}
        settlementAmount={settlementAmount}
        setReloadData={setReloadData}
        // setSendNotification={draftToHtml(
        //   convertToRaw(editorState.getCurrentContent())
        // )}
        // setSendBody={test}
        // canSendSms={canSendSms}
        // titleNotice={titleNotice}
        allowRoute={true}
      />
      <ModalCancelPaymentSettlement
        openModel={openCancelModal}
        setSendConfirmation={setSendConfirmation}
        setOpenVerifyModal={setOpenCancelModal}
        paymentKey={paymentKey}
        settlementAmount={settlementAmount}
        setReloadData={setReloadData}
        // setSendNotification={draftToHtml(
        //   convertToRaw(editorState.getCurrentContent())
        // )}
        // setSendBody={test}
        // canSendSms={canSendSms}
        // titleNotice={titleNotice}
        allowRoute={true}
      />
    </div>
  );
}
const onKeyDown = (e: any) => {
  e.preventDefault();
};
